// The public site must never send visitors to a staging environment, even when
// a profile CTA, article link or runtime setting still points at one.
export function isStagingUrl(url: string) {
  try {
    const { hostname } = new URL(url);
    return hostname.toLowerCase().split(".").includes("staging");
  } catch {
    return false; // relative links stay on this site
  }
}
